export enum DeviceType {
  KIOSK = 'kiosk',
  CUSTOMER_MONITOR = 'customer_monitor',
  KITCHEN_MONITOR = 'kitchen_monitor',
  PRINTER = 'printer',
  QR_CODE = 'qr_code',
}
